import * as yup from 'yup'

const collapse = yup.object().shape(
  {
    plan: yup
      .object()
      .nullable()
      .when('itemType', {
        is: itemType => itemType === 'planType',
        then: yup.object().required('O plano deve ser selecionado'),
      }),
    description: yup.string().when('itemType', {
      is: itemType => itemType === 'entryType',
      then: yup
        .string()
        .required()
        .trim(),
    }),
    price: yup
      .number()
      .min(0, 'O valor precisa ser maior ou igual a R$ 0,00')
      .required(),
    from: yup
      .date()
      .nullable()
      .default(null)
      .when('till', {
        is: till => till,
        then: yup
          .date()
          .required()
          .default(null),
      }),
    till: yup
      .date()
      .nullable()
      .default(null)
      .when('from', {
        is: from => from,
        then: yup
          .date()
          .required()
          .default(null)
          .min(yup.ref('from'), 'Data final deve ser maior que a data inicial'),
      }),
  },
  ['from', 'till'],
)

export default collapse
